<section class="withdrawal-page">
  <div class="wrapper">
    <div class="panel">
      <header class="header" *ngIf="!isSubmitted && !confirmationData">
        <h1 class="title">Vertrag widerrufen</h1>
        <p class="subtitle">
          Bitte füllen Sie die folgenden Felder aus, um Ihren Widerruf
          durchzuführen.
        </p>
      </header>
      <form
        [formGroup]="withdrawalForm"
        (ngSubmit)="onSubmit()"
        class="section"
        [ngClass]="{ hasError: hasError }"
        *ngIf="!isSubmitted"
      >
        <h2>Ihre Kontaktdaten</h2>

        <div class="infoText" *ngIf="viewState.showNoOffersInfo">
          <span class="infoIcon">i</span>
          <div>
            Sie haben derzeit keine aktiven Verträge. <br />
            Sobald Sie einen Vertrag abschließen, können Sie diesen hier
            innerhalb von <strong>14 Tagen</strong> widerrufen.
          </div>
        </div>

        <div class="row">
          <label for="product">Produkt</label>
          <div class="selectWrapper">
            <select formControlName="product" id="product">
              <option [value]="withdrawalProductKredit">Kredit</option>
              <option value="RSV">Restschuldversicherung</option>
              <option value="EKS">Einkommensschutz24</option>
            </select>
            <svg-icon
              src="/resultpage/assets/icons/Chevron_Arrow.svg"
              [ngClass]="['arrowIcon']"
              [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
            ></svg-icon>
          </div>
        </div>

        <app-withdrawal-bank-selector
          *ngIf="viewState.showBankSelector"
          [form]="withdrawalForm"
        />

        <app-withdrawal-application-selector
          *ngIf="viewState.showLoggedInApplicationSelector"
          [form]="withdrawalForm"
          [options]="availableTransactionOptions"
          variant="select"
        />

        <app-withdrawal-external-redirect
          *ngIf="viewState.showExternalRedirect && viewState.activeBankGateway"
          [bankGateway]="viewState.activeBankGateway"
        />

        <app-withdrawal-inline-form
          *ngIf="viewState.showInlineForm"
          [form]="withdrawalForm"
          [transactionOptions]="availableTransactionOptions"
          [applicationSelectorVariant]="applicationSelectorVariant"
          [hasError]="hasError"
          [errorMessage]="getErrorMessage()"
          [isSubmitting]="isSubmitting"
        />
      </form>

      <!-- withdrawal confirm -->
      <div class="section confirm" *ngIf="isSubmitted && confirmationData">
        <h1 class="title">Widerruf eingereicht</h1>
        <p class="subtitle">
          Ihre Widerrufserklärung wurde erfolgreich eingereicht.
        </p>
        <div class="infoSection">
          <div class="row">
            <div class="label">Antragsnummer:</div>
            <div class="value">{{ confirmationData.c24Id }}</div>
          </div>
          <div class="row">
            <div class="label">Datum:</div>
            <div class="value">{{ confirmationData.date }}</div>
          </div>
          <div class="row">
            <div class="label">Uhrzeit:</div>
            <div class="value">{{ confirmationData.time }}</div>
          </div>
          <div class="row">
            <div class="label">Status:</div>
            <div class="value success">{{ confirmationData.status }}</div>
          </div>
        </div>
        <div class="infoAlert">
          <svg-icon
            [ngClass]="['tickIcon']"
            src="/resultpage/assets/icons/check.svg"
            [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
            aria-hidden="true"
          />
          <p>
            Eine Bestätigung wurde an
            <a [href]="'mailto:' + confirmationData.email">{{
              confirmationData.email
            }}</a>
            versendet. Bitte prüfen Sie auch Ihren Spam-Ordner.
          </p>
        </div>
        <div class="stepsSection">
          <h2>Nächste Schritte</h2>
          <ul>
            <li>
              <svg-icon
                [ngClass]="['tickIcon']"
                src="/resultpage/assets/icons/check.svg"
                [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
                aria-hidden="true"
              />
              <span>
                Ihre Widerrufserklärung wird an die Bank weitergeleitet und
                schnellstmöglich bearbeitet</span
              >
            </li>
            <li>
              <svg-icon
                [ngClass]="['tickIcon']"
                src="/resultpage/assets/icons/check.svg"
                [svgStyle]="{ 'width.px': 14, 'height.px': 14 }"
                aria-hidden="true"
              />
              <span
                >Sie erhalten eine weitere Bestätigung per E-Mail, sobald der
                Widerruf erfolgreich bearbeitet wurde</span
              >
            </li>
          </ul>
        </div>
      </div>
      <!-- withdrawal confirm end -->
    </div>
  </div>

  <!-- Confirmation Dialog Templates -->
  <ng-template #confirmDialogContent>
    <h2>Widerruf bestätigen</h2>
    <p>Sind Sie sicher, dass Sie den Antrag widerrufen möchten?</p>
    <div class="offer-label" *ngIf="confirmationLabel">
      {{ confirmationLabel }}
    </div>
  </ng-template>

  <ng-template #confirmDialogActions let-close="close">
    <button
      type="button"
      class="btn-secondary"
      (click)="close()"
      [disabled]="isDialogSubmitting"
    >
      abbrechen
    </button>
    <button
      type="button"
      class="btn-primary"
      (click)="onConfirmClick(); close()"
      [disabled]="isDialogSubmitting"
    >
      jetzt widerrufen
      <span *ngIf="isDialogSubmitting" class="loader"></span>
    </button>
  </ng-template>
</section>
